import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconWarningAmberSvg } from "./IconWarningAmberSvg.mjs";
const IconWarningAmber = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconWarningAmberSvg, ...iconProps });
};
export {
  IconWarningAmber
};
